import { removePathsFromError, stringifyError } from 'shared/functions';

const Error = ({ error }) => {
  if (!error) {
    return null;
  }

  const errorWithoutPath = removePathsFromError(error);
  return <div className="text-danger">{stringifyError(errorWithoutPath)}</div>;
};

export { Error };
